// Labels for the `check` values in server/modules/classification_pipeline/preflight_checks.py
export const CHECK_LABELS = {
  geocode: "Missing geocode",
  forum_source_text: "No source text",
  forum_translation: "Missing translation",
  linkedin_profile: "Profile step not run",
};

/** What each check looks for, shown on the page so the result is self-explanatory. */
export const CHECK_DESCRIPTIONS = [
  "Every selected platform: rows must have geocode data (latitude and longitude)",
  "Forum Data: Maimai and OnePointThreeAcresForum rows must have an English translation",
  "Linkedin Facebook Data: raw Linkedin rows must have been through the profile step",
];

/** One row per failing check. Read-only — the form above is where input happens. */
export const PREFLIGHT_ISSUE_COLUMNS = [
  { field: "company_name", headerName: "Company", width: 180 },
  { field: "check", headerName: "Check", width: 190 },
  { field: "platform", headerName: "Platform", width: 200 },
  { field: "row_count", headerName: "Rows", width: 90, type: "number" },
  { field: "row_ids", headerName: "Row IDs", flex: 1, minWidth: 200 },
];

/**
 * Flatten the per-company report into DataGrid rows, one per failing check.
 *
 * The server caps reported IDs, so a check with more rows than IDs gets a "+N more"
 * tail rather than looking like it only affects the ones listed.
 */
export function mapPreflightIssueRows(results) {
  const rows = [];
  results.forEach((result) => {
    (result.issues ?? []).forEach((issue, index) => {
      const ids = issue.row_ids ?? [];
      const hidden = (issue.row_count ?? 0) - ids.length;
      rows.push({
        id: `${result.company_name}-${issue.check}-${issue.platform}-${index}`,
        company_name: result.company_name,
        check: CHECK_LABELS[issue.check] ?? issue.check,
        platform: issue.platform,
        row_count: issue.row_count,
        row_ids: hidden > 0 ? `${ids.join(", ")} +${hidden} more` : ids.join(", "),
      });
    });
  });
  return rows;
}
